import { useRootSelector } from '../../../../../store/hooks';
import { selectOptions } from '../../../../../store/features/options';
import { selectSiteType } from '../../../../../store/features/siteType';
import { selectPricingPackagesCount } from '../../../store/features/packages';
import { DeliveryType } from '../../../../../constants';
import { SiteTypes } from '../../../../../types';

export interface UseCustomSeatLimitReturn {
  limit: number;
  limitReached: boolean;
}

export function useCustomSeatLimit(): UseCustomSeatLimitReturn {
  const { deliveryType } = useRootSelector(selectOptions);
  const { type: siteType } = useRootSelector(selectSiteType);
  const addedPackagesCount = useRootSelector(selectPricingPackagesCount);

  if (siteType === SiteTypes.COURSE && deliveryType === DeliveryType.DISTANCE) {
    return { limit: 1, limitReached: addedPackagesCount >= 1 };
  }

  return { limit: -1, limitReached: false };
}
